<template>
    <div>
      <h5 class="pb-1 pr-3 pl-3 pt-2 float-left">{{group.name}}
        <br><small class="text-muted">{{group.total_templates}} template messages</small>
      </h5>
        <div class="toolbar float-right pt-3 pr-3">
          <div class="btn-group mr-1">
            <b-button v-b-tooltip.hover @click="showAddMessageModal" title="Compose template" variant="light"><span class="icon-note icons font-1xl"></span></b-button>
            <b-button v-b-tooltip.hover title="Delete group" @click="handleDeleteGroup" v-if="group.personal" variant="light"><span class="icon-trash icons font-1xl"></span></b-button>
          </div>
          <div class="btn-group">
            <b-button v-b-tooltip.hover @click="handleReload" title="Reload" variant="light"><span class="icon-refresh icons font-1xl"></span></b-button>
          </div>
        </div>
        <div style="clear:both"></div>
        <hr class="m-0 p-0">
        <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-y-reach-end="scrollHandle">
          <div class="mr-5">
            <div class="border-0">
              <div class="">
                  <main class="inbox border-0 padding-0">
                  <keep-alive>
                      <component
                        :is="TemplateList"
                        :group="group"
                        @template-message-edit="handleMessageEdit"
                        @template-message-delete="handleMessageDelete"
                        @template-send-as-sms="handleSendAsSMS"
                      ></component>
                  </keep-alive>
                  <!--
                    @birthday-group-message-selection="messageSelection"
                    @birthday-group-contact-toggle="handleContactToggle"
                    @birthday-group-message-toggle="handleMessageToggle"
                  -->
                  </main>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      <b-modal :title="modalTitle" hide-footer v-model="showMessageModal">
        <template>
          <div class="form-row mb-3">
            <b-col cols="12" sm="12">
              <textarea v-model="content" class="form-control" id="pn" placeholder="type message"></textarea>
              <small class="text-danger">Add <b>[name]</b> tag anywhere in your message to enable addressing recipients by name.</small>
            </b-col>
            <div class="pull-right block">
              <span class="small muted" v-if="hasContent">{{ pageCharacters }}</span>
            </div>
          </div>
        </template>
        <b-button type="button" variant="primary" class="mt-1" block @click="handleSaveMessage">
          <span v-if="!loading">{{actionText}}</span>
          <div class="sk-circle" v-if="loading">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
          </div>
          <i v-if="flashSendError" class="fa fa-times"></i>
        </b-button>
      </b-modal>
      <b-modal title="Send as SMS" hide-footer v-model="isSending">
        <keep-alive>
          <component
            :is="composeSMS"
            :isDialog="true"
            :contentToSend="contentToSend"
            :newsletters="newsletterOptions"
          ></component>
        </keep-alive>
      </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from "vuex"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import FileReader from 'vue-filereader' 
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import TemplateList from './TemplateList'
import composeSMS from '@/components/messages/ComposeSMS'

Vue.use(VueSweetalert2)

export default {
  name: 'GroupView',
  components: {
    VuePerfectScrollbar,
    vSelect,
    FileReader,
    TemplateList,
    composeSMS,
  },
  data () {
    return {
      TemplateList: TemplateList,
      showModal : false,
      modalTitle : 'Compose template message',
      name: '',
      actionText: 'Save',
      flashSendError: false,
      modalForm : 0,
      selectedMessages: [],
      showMessageModal: false,
      hasContent: false,
      pageCharacters: '',
      content: '',
      message: null,
      editing: false,
      isSending: false,
      composeSMS: composeSMS,
      contentToSend: '',
    }
  },
  props: {
    group: {
      type: Object,
      default: null
    },
  },
  notifications: {
    showMessageSuccess: {
      title: 'Success',
      message: 'Teplate message was saved successfully!',
      type: 'success'
    },
    showTemplateFailed: {
      title: 'Failed',
      message: 'Could not save template message at this time!',
      type: 'error'
    },
    showValidationError: {
      title: 'Failed',
      message: 'Name is required and phone number must be in intl format!',
      type: 'error'
    },
    showMessageValidationError: {
      title: 'Failed',
      message: 'All fields are required',
      type: 'error'
    },
    showDeleteSuccess: {
      title: 'Success',
      message: 'Deleted successfully',
      type: 'success'
    },
    showDeleteError: {
      title: 'Success',
      message: 'Unable to delete now. Kindly try again',
      type: 'success'
    },

  },
  computed: {
    ...mapState('smsCollection', ['groups', 'loading', 'serverResponse']),
    ...mapState('user', ['user']),
    ...mapState('newsletter', ['newsletters', 'nextPage']),
    psSettings: () => {
      return {
        maxScrollbarLength: 60,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    },
    newsletterOptions() {
      let newsletterOptions = []
      this.newsletters.forEach(function (newsletter, key) {
          newsletterOptions.push({ value: newsletter.id, label: `${newsletter.name} (${newsletter.total_subscribers})` });
      })
      return newsletterOptions
    },
  },
  methods: {
    ...mapActions('smsCollection', [
        'fetchGroups',
        'deleteGroup',
        'saveMessage',
        'deleteMessage',
        'toggleMessage',
        'fetchGroup',
        'fetchGroupTemplates',
        'updateMessage',
    ]),
    ...mapActions('newsletter', [
        'fetchNewsletters'
    ]),
    scrollHandle (evt) {
      this.$emit(`load-more-templates}`)
    },
    handleReload: async function() {
      this.group.templates = []
      this.fetchGroupTemplates({groupId: this.group.id, page: 1})
    },

    handleDeleteGroup() {
      if (this.loading) {
        this.$swal('You have already clicked delete button')
        return
      }

      this.$swal({
        title: "Delete sms template group",
        text: "Sure you want to delete this sms template group?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => { 
        if (result.value) {
          if(this.loading)
            return 

          let status = this.deleteGroup({id:this.group.id})
          
          if( ! status ) {
            this.showDeleteError({message: this.serverResponse.message})
          } else {
            this.showDeleteSuccess()
            this.$emit('all-template-group-selections', false)
          }
        }
      })
    },

    showAddMessageModal: function() {
      this.content = ''
      this.actionText = 'Save'
      this.modalTitle = 'Compose template'
      this.editing = false
      this.showMessageModal = true
    },

    handleMessageEdit: function(sms) {
      this.message = sms
      this.content = sms.message
      this.actionText = 'Update'
      this.modalTitle = 'Edit template message'
      this.editing = true
      this.showMessageModal = true
    },

    async handleSaveMessage(){

      if(this.loading)
        return

      if(this.content.trim().length == 0) {
        this.showMessageValidationError()
        return
      }

      const requestData = {
          "message": this.content,
        }

      let status = false
      if (!this.editing) {
        status = await this.saveMessage({ data: requestData, groupId : this.group.id} )
      } else {
        status = await this.updateMessage({ data: requestData, groupId : this.group.id, id: this.message.id} )
      }

      if( !status ) {
        //this.actionText = this.editing ? 'Update message' : 'Save message'
        this.flashSendError = true
        this.showTemplateFailed({message: this.serverResponse.message})

        let interval = setInterval(() => {
          this.actionText = this.editing ? 'Update' : 'Save'
          this.flashSendError = false
          clearInterval(interval)
        }, 1000)
      } else {
        this.showMessageSuccess()
        this.showMessageModal = false
        this.content = ''
      }
    },

    handleMessageDelete: function(id) {
      this.$swal({
        title: "Delete template",
        text: "Sure you want to delete this template?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => { 
        if (result.value) {

          if(this.loading)
            return 
          
          let status = this.deleteMessage({groupId:this.group.id, id: id})
          if( ! status ){
            this.showDeleteError({message: this.serverResponse.message})
          } else {
            this.showDeleteSuccess()
          }
        }
      })
    },

    handleMessageToggle: function(id) {
      if(this.loading)
            return 
          
      this.toggleMessage({groupId: this.group.id, id: id})
    },
    handleSendAsSMS: function(content) {
      this.contentToSend = content
      this.isSending = true
    }
  },
  watch: {
    content(newValue, oldValue) {
      const MAX_SINGLE = 160;
      const MAX_MULTIPLE = 151;
      let pageLen = this.content.length <= MAX_SINGLE ? MAX_SINGLE : MAX_MULTIPLE;
      let pages = Math.ceil(this.content.length/pageLen);
      
      this.pageCharacters = `Pages: ${pages} (Maximum Charaters: ${(pageLen*pages)}), Characters left: ${(pageLen*pages-this.content.length)}, Typed Characters: ${this.content.length}`

      this.hasContent = this.content.length > 0
    },
  },
  created() {
    if (this.newsletters.length <= 0) {
      this.fetchNewsletters({page:this.nextPage})
    }
  },
}
</script>

<style lang="css" scoped>
  .content-border {
    border: 1px #edebe9 solid;
  }
  
  .scroll-area {
    position: relative;
    height: calc(100vh - 20.5vh);
  }

  .sk-circle{
    margin: 0 auto 1px auto;
    width: 15px;
    height: 15px;
    position: relative;
    color: white !important;
  }
</style>

